// extracted by mini-css-extract-plugin
export default {"empty":"EmptyInvoice_empty__qwpZ8","icon":"EmptyInvoice_icon__REDPo"};